import { declareVconsoleComponent } from '/vodalys/vvuejs/declareVconsoleComponent.mjs'
 
import Question24TagEditor from './Question24TagEditor.vue' 

declareVconsoleComponent('question24TagEditor', Question24TagEditor, 'question24:tag_editor');